var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequiredAsterisk = function SvgRequiredAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    Required\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.355l2.246-6.934c5.176 1.823 8.936 3.402 11.279 4.736-.619-5.892-.944-9.945-.977-12.158h7.08c-.098 3.223-.472 7.259-1.123 12.109 3.353-1.693 7.194-3.255 11.523-4.687l2.246 6.934c-4.134 1.367-8.187 2.279-12.158 2.734 1.986 1.725 4.785 4.801 8.398 9.229l-5.859 4.15c-1.888-2.572-4.118-6.071-6.689-10.498-2.409 4.59-4.525 8.089-6.348 10.498l-5.762-4.15c3.776-4.655 6.478-7.731 8.105-9.229A175.508 175.508 0 010 14.355"
  })));
};
export default SvgRequiredAsterisk;